import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { getProfile } from '@/hooks/getAuth'

export default function GenerateReport() {
  const { token, ranchId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const parcelId = searchParams.get('parcelId')

  useEffect(() => {
    if (token) {
      getProfile(token).then((res) => {
        if(res.status === 'success') {
          const now = new Date()
          localStorage.setItem('auth',
            JSON.stringify({
              sessionKey: token,
              status: res.status,
              name: res.profile['fullname'],
              tier: res.profile['tier'],
              firstname: res.profile['firstname'],
              lastname: res.profile['lastname'],
              email: res.profile['email'],
              notifyHsChange: res.profile['notify_hs_change'],
              expiry: now.getTime() + 7200000, // 2 hours
              tutorial: res.profile['tutorial'],
            })
          )
          const baseUrl = parcelId ? `/?ranchId=${ranchId}` : `/portfolio/?ranchId=${ranchId}`;
          window.location.href = `${baseUrl}&${searchParams.toString()}`;
        }
        else {
          setSearchParams((prevParams) => {
            const newParams = new URLSearchParams(prevParams)
            newParams.set('status', JSON.stringify({status: 'fail', error: res.status}))
            return newParams
          })
        }
      })
    }
  }, [token])

  return <div></div>
}
